export const scrollTo = (options) => window.scrollTo(options);
